// Offline check-in queue: when the gate loses signal, scans are stored locally
// and flushed when the connection returns. Failures on sync are dropped silently.
const KEY = "st_staff_checkin_queue";
const EVT = "st-staff-queue-changed";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
function write(items) {
  try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* noop */ }
  try { window.dispatchEvent(new Event(EVT)); } catch { /* noop */ }
}

export function queueSize() { return read().length; }

export function enqueueCheckin(item) {
  const items = read();
  items.push({ ...item, queued_at: Date.now() });
  write(items);
}

export function onQueueChange(cb) {
  window.addEventListener(EVT, cb);
  return () => window.removeEventListener(EVT, cb);
}

// post: async (item) => response data ({ ok, ... }); must THROW on network error.
// Returns { admitted, processed }. Network error stops the flush (items kept).
export async function flushQueue(post) {
  let items = read();
  let admitted = 0;
  let processed = 0;
  while (items.length) {
    const item = items[0];
    try {
      // eslint-disable-next-line no-await-in-loop
      const data = await post(item);
      if (data && data.ok) admitted += 1;
      processed += 1;
      items = items.slice(1);
      write(items);
    } catch (e) {
      if (e && e.response) {
        // server responded (e.g. rejected/invalid) → drop this item and keep going
        processed += 1;
        items = items.slice(1);
        write(items);
        continue;
      }
      break; // no response → offline again, keep the rest for next time
    }
  }
  return { admitted, processed };
}
